import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  output,
  ViewChild,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';

import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { EmojiEvent } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule,
  DropdownModule,
  DropdownTriggerForDirective,
  EmojiModule,
  IconModule,
  TextAreaComponentModule,
} from '@hglobal/common';
import { UiStore } from '@pt/services';

@Component({
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    TextAreaComponentModule,
    EmojiModule,
    DropdownModule,
    IconModule,
    PickerModule,
  ],
  selector: 'pt-comment-form',
  templateUrl: './comment-form.component.html',
  styleUrl: './comment-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentFormComponent implements OnInit {
  readonly uiStore = inject(UiStore);

  readonly #formBuilder = inject(FormBuilder);

  @ViewChild('dropdownRef') emojiTrigger: DropdownTriggerForDirective;

  content = input<string>();

  formSubmitted = output<string>();

  form = this.#formBuilder.group({
    content: '',
  });

  ngOnInit(): void {
    this.form.patchValue({ content: this.content() });
  }

  selectEmoji({ emoji }: EmojiEvent): void {
    this.form.patchValue({ content: `${this.form.value.content || ''}${emoji.native}` });
    this.emojiTrigger.toggleDropdown();
  }

  onSubmit(): void {
    this.formSubmitted.emit(this.form.value.content);
    this.form.reset();
  }
}
